import React from "react";
import { useLocation } from "react-router-dom";

const NominaDetalles = () => {
  const location = useLocation();
  // console.log(location.state.applicationStatus);
  return <div>{JSON.stringify(location)}</div>;
};

export default NominaDetalles;
